import React from 'react';

import { withFirebase } from '../../firebase';
import Moment from 'react-moment';

const MatchesListItem = (props) => {

    const { match, teams, showMatchForm } = props;

    const teamA = teams.find((team) => match.teamA == team.uid);
    const teamB = teams.find((team) => match.teamB == team.uid);

    // let resultOrTime = match.result && match.result.goalsA != null && match.result.goalsB != null ?
    //     <span>{match.result.goalsA + " - " + match.result.goalsB}</span>
    //     :
    //     (match.date && <Moment format="HH:mm">{match.date}</Moment>) || <span>- : -</span>

    let resultOrTime;
    if (match.result && match.result.goalsA != null && match.result.goalsB != null) {
        resultOrTime = <span className="d-block bg-bluegray pr-1 pl-1 rounded">{match.result.goalsA + " - " + match.result.goalsB}</span>
        if ((match.result.goalsA == match.result.goalsB) &&
            match.result.penaltiesA != null && match.result.penaltiesA != null) {
            resultOrTime = (
                <>{resultOrTime}
                    <span className="small d-block">({match.result.penaltiesA + " - " + match.result.penaltiesB})</span>
                </>
            )
        }
    } else {
        resultOrTime = (match.date && <Moment format="HH:mm">{match.date}</Moment>) || <span>- : -</span>
    }


    const teamALogo = (teamA && teamA.logoUrl) ? teamA.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"
    const teamBLogo = (teamB && teamB.logoUrl) ? teamB.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"

    return (
        <tbody className="small bg-hover" onClick={() => showMatchForm(match)} data-toggle="tooltip" data-placement="top" title="Editar">
            <tr className=" border-top border-white pt-2 pb-2" >
                <td className="w-50 pt-1 pr-1 text-right align-middle">
                    <span className="align-self-center text-wrap text-truncate">
                        {(teamA && teamA.title) || <span className="text-black-50 font-italic">sin equipo</span>}
                    </span>
                </td>
                <td className="pt-1 pb-0 align-middle">
                    <div style={{
                        backgroundImage: `url(${teamALogo})`,
                        height: 25,
                        width: 25,
                        minWidth: 25,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                    }} />
                    {/* <img className="" src={(teamA && teamA.logoUrl) || teamLogo} height="25" width="25" alt="" /> */}
                </td>

                <td className="text-nowrap pt-1 pl-2 pr-2 align-self-center font-weight-bold align-middle text-center">
                    {resultOrTime}
                </td>

                <td className="pt-1 pb-0 align-middle">
                    <div style={{
                        backgroundImage: `url(${teamBLogo})`,
                        height: 25,
                        width: 25,
                        minWidth: 25,
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                    }} />
                    {/* <img className="" src={(teamB && teamB.logoUrl) || teamLogo} height="25" width="25" alt="" /> */}
                </td>
                <td className="w-50 pt-1 pl-1 align-middle">
                    <span className="align-self-center text-wrap text-truncate">
                        {(teamB && teamB.title) || <span className="text-black-50 font-italic">sin equipo</span>}
                    </span>
                </td>
            </tr >
            <tr className=" border-bottom border-white align-middle">
                <td colSpan="5" className="text-center text-black-50 font-italic pt-0">{(match.place && match.place) || "-"}</td>
            </tr>
        </tbody>
    )
}

export default withFirebase(MatchesListItem);
